<main class="main" *ngIf="authService.currentUser">
  <div class="panel">
    <div class="menu">
      <input placeholder="{{ 'content.search' | transloco }}"
             type="text" class="search"
             [(ngModel)]="searchText" (input)="findElement()" appBlurOnEnter />
      <label>{{ 'content.sourceType' | transloco }}</label>
      <fieldset>
        <label>
          <input type="radio"
                 name="source"
                 [checked]="!isShowBI"
                 (change)="toggleIsBI(false);" />
          DWH
        </label>
        <label>
          <input type="radio"
                 name="source"
                 [checked]="isShowBI"
                 (change)="toggleIsBI(true);" />
          BI
        </label>
      </fieldset>
      <div class="ds-dropdown" [class.closed]="!open">
        <div class="ds-header" role="button" tabindex="0" (click)="toggleOpen()">
          <span class="ds-title">{{'content.source' | transloco }}</span>
          <svg class="ds-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M5.46967 6.53043C5.76256 6.82332 6.23744 6.82332 6.53033 6.53043L11.3033 1.75746C11.5962 1.46457 11.5962 0.989692 11.3033 0.6968C11.0104 0.403906 10.5355 0.403906 10.2426 0.696799L6 4.93944L1.75736 0.696799C1.46447 0.403906 0.989593 0.403906 0.696699 0.696799C0.403806 0.989692 0.403806 1.46457 0.696699 1.75746L5.46967 6.53043ZM6 6L5.25 6L5.25 6.0001L6 6.0001L6.75 6.0001L6.75 6L6 6Z" fill="#7855ED" />
          </svg>
        </div>

        <div class="ds-body">
          <div class="chips">
            <div *ngFor="let source of sources">
              <button type="button"
                      class="chip"
                      [class.selected]="isSelected(source)"
                      (click)="select(source)">
                {{ source.dataSourceName }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="ds-dropdown menu-objects" *ngIf="!isShowBI">
        <div class="ds-header" role="button" tabindex="0">
          <span class="ds-title">{{'content.chooseSchema' | transloco }}</span>

          <button *ngIf="!isShowBI" [disabled]="!this.currentDataSource" class="update" (click)="updateMeta()" [title]="'content.updateMeta' | transloco"></button>
        </div>

        <div class="ds-body">
          <div class="chips">
            <button *ngFor="let schema of schemas"
                    type="button"
                    class="chip"
                    [class.selected]="isSchemaSelected(schema)"
                    (click)="selectSchema(schema)">
              {{ schema.name }}
            </button>
          </div>
          <label *ngIf="schemas.length === 0">
            {{'content.noSources' | transloco }}
          </label>
        </div>
        <hr *ngIf="schemas.length > 0" class="dwh-separator" />
        <div class="menu-body">
          <details *ngIf="tables.length > 0" [attr.open]="(isSearching || elementType === 'Table') ? '' : null">
            <summary>{{'content.tables' | transloco }}</summary>
            <div class="menu-elements">
              <div *ngFor="let table of tables">
                <button [id]="'element-Table-' + table.id"
                        (click)="displayElement(table.id, 'Table')"
                        class="chip" [class.selected]="isSelectedElement(table, 'Table')">
                  {{table.name}}
                </button>
              </div>
            </div>

          </details>
          <details *ngIf="procedures.length > 0" [attr.open]="(isSearching || elementType === 'Procedure') ? '' : null">
            <summary>{{'content.procedures' | transloco }}</summary>
            <div class="menu-elements">
              <div *ngFor="let procedure of procedures">
                <button [id]="'element-Procedure-' + procedure.id"
                        (click)="displayElement(procedure.id, 'Procedure')"
                        class="chip" [class.selected]="isSelectedElement(procedure, 'Procedure')">
                  {{procedure.name}}
                </button>
              </div>
            </div>
          </details>
          <details *ngIf="functions.length > 0" [attr.open]="(isSearching || elementType === 'Function') ? '' : null">
            <summary>{{'content.functions' | transloco }}</summary>
            <div class="menu-elements">
              <div *ngFor="let function of functions">
                <button [id]="'element-Function-' + function.id"
                        (click)="displayElement(function.id, 'Function')"
                        class="chip" [class.selected]="isSelectedElement(function, 'Function')">
                  {{function.name}}
                </button>
              </div>
            </div>
          </details>
          <details *ngIf="views.length > 0" [attr.open]="(isSearching || elementType === 'View') ? '' : null">
            <summary>{{'content.views' | transloco }}</summary>
            <div class="menu-elements">
              <div *ngFor="let view of views">
                <button [id]="'element-View-' + view.id"
                        (click)="displayElement(view.id, 'View')"
                        class="chip" [class.selected]="isSelectedElement(view, 'View')">
                  {{view.name}}
                </button>
              </div>
            </div>
          </details>
        </div>
      </div>
      <div class="ds-dropdown reports-in-folder" *ngIf="isShowBI">
        <div *ngIf="isLoadingAsync" class="node-loading" style="display:flex; justify-content:flex-end; align-items:center; width: 100%; height: 0.5rem;">
          <app-loading-inline [size]="'0.5rem'"></app-loading-inline>
        </div>

        <ng-container *ngIf="folderTree?.length">
          <ng-container *ngFor="let node of folderTree">
            <ng-container *ngTemplateOutlet="nodeTpl; context: {$implicit: node}"></ng-container>
          </ng-container>
        </ng-container>

        <ng-template #nodeTpl let-node>
          <details [attr.open]="isSearching ? '' : null">
            <summary>
              <div class="folder">
                {{ node.name }}
                <svg width="16" height="16" viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M4.5 11.5a3 3 0 0 1 3-3h8.718a4 4 0 0 1 2.325.745l4.914 3.51a4 4 0 0 0 2.325.745H40.5a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3h-33a3 3 0 0 1-3-3zm0 8h39" /></svg>
              </div>
            </summary>
              <div class="menu-elements">
                <div *ngFor="let report of (node.filteredReports || node.reports || [])">
                  <button [id]="'element-Report-' + report.id"
                          (click)="displayReport(report.id)" class="chip" [class.selected]="isSelectedElement(report, 'Report')">
                    {{ report.name }}
                  </button>
                </div>
              </div>
              <div *ngIf="node.children?.length" class="child-folder">
                <ng-container *ngFor="let child of node.children">
                  <ng-container *ngTemplateOutlet="nodeTpl; context: {$implicit: child}"></ng-container>
                </ng-container>
              </div>
          </details>
        </ng-template>

      </div>

      <div class="ds-dropdown" *ngIf="isShowBI && currentDataSource">
        <div *ngIf="isLoadingAsync" class="node-loading" style="display:flex; justify-content:flex-end; align-items:center; width: 100%; height: 0.5rem;">
          <app-loading-inline [size]="'0.5rem'"></app-loading-inline>
        </div>
        <p class="ds-title">{{'content.metricsGroup' | transloco }}</p>
        <div class="summarized-metrics">
          <div *ngFor="let group of filteredSummarizedMetrics">
            <div class="menu-elements">
              <button class="chip" (click)="showMetrics(group.id)" [class.selected]="isSelectedElement(group, 'ReportMetric')">
                {{group.summarizedMetricName}}
              </button>
            </div>
          </div>
        </div>
        
      </div>

    </div>
    <div class="content">
      <div *ngIf="currentElement != undefined && elementType != 'ReportMetric'">
        <div class="page-buttons">
          <div>
            <button class="update-desc" (click)="updateDesc()" *ngIf="!isShowBI">
              {{'content.updateDesc' | transloco }}
            </button>
            <button class="edit" (click)="toggleEditing()" [class.save]="isEdit">
              {{ isEdit ? ('content.save' | transloco) : ('content.edit' | transloco) }}
            </button>


            <button (click)="exportToPDF()" class="export">{{'content.exportToPDF' | transloco }}</button>
            <button class="upload" (click)="updateDataCatalogDesc()">{{'content.loadToDataCatalog' | transloco }}</button>
            <button class="lineage" (click)="openLineage()">{{'content.dataLineage' | transloco }}</button>
            <button *ngIf="isShowBI && currentDataSource.dbType.toLowerCase() === 'power bi'" class="load" (click)="loadFile()">{{'content.loadFile' | transloco }}</button>
          </div>

          <button class="apply" (click)="applyElement()">
            {{ currentElement.status ? ('content.toUnapply' | transloco) : ('content.toApply' | transloco) }}
          </button>

        </div>
        <hr />
        <div class="main-part" style="width:100%" *ngIf="!isShowBI">
          <!-- Таблица -->
          <div *ngIf="elementType==='Table'" class="detail-information">
            <div class="page-buttons">
              <h2>{{currentElement.name}}</h2>
              <div class="history-changes">
                <label class="subtitle">{{'content.historyChange' | transloco }}</label>

                <div class="custom-dropdown" [class.open]="isOpen" (click)="isOpen = !isOpen">
                  <div class="dropdown-header">
                    {{ currentElement?.name || ('content.chooseElement' | transloco)  }}
                  </div>

                  <div class="dropdown-body" *ngIf="isOpen">
                    <div class="dropdown-item"
                         *ngFor="let el of historyElements"
                         (click)="selectElement(el, 'Table')">
                      {{ el.name }} ({{ (el.modifyDt ?? el.createDt) | date:'dd.MM.yyyy HH:mm' }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="element-block">
              <label class="subtitle">{{'content.description' | transloco }}</label>
              <textarea *ngIf="isEdit" class="edit-textarea"
                        [(ngModel)]="currentElement.description"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"></textarea>
              <p *ngIf="!isEdit">
                {{ currentElement?.description ? currentElement.description : ('content.emptyElement' | transloco) }}
              </p>
            </div>

            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>{{'content.columnName' | transloco }}</th>
                    <th>{{'content.type' | transloco }}</th>
                    <th>{{'content.description' | transloco }}</th>
                    <th>{{'content.constraints' | transloco }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let column of currentElement.columns">
                    <td>
                      {{ column.name }}
                    </td>

                    <td>
                      {{ column.type }}
                    </td>

                    <td>
                      <ng-container *ngIf="isEdit; else viewDesc">
                        <textarea cdkTextareaAutosize
                                  #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="1"
                                  [(ngModel)]="column.description">
                    </textarea>
                      </ng-container>
                      <ng-template #viewDesc>{{ column.description }}</ng-template>
                    </td>

                    <td>
                      {{ column.constraints }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Процедура -->
          <div *ngIf="elementType==='Procedure'" class="detail-information">
            <div class="page-buttons">
              <h2>{{currentElement.name}}</h2>

              <div class="history-changes">
                <label class="subtitle">{{'content.historyChange' | transloco }}</label>

                <div class="custom-dropdown" [class.open]="isOpen" (click)="isOpen = !isOpen">
                  <div class="dropdown-header">
                    {{ currentElement?.name || ('content.chooseElement' | transloco)  }}
                  </div>
                  <div class="dropdown-body" *ngIf="isOpen">
                    <div class="dropdown-item"
                         *ngFor="let el of historyElements"
                         (click)="selectElement(el, 'Procedure')">
                      {{ el.name }} ({{ (el.modifyDt ?? el.createDt) | date:'dd.MM.yyyy HH:mm' }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-blocks">
              <div class="element-block">
                <label class="subtitle">{{'content.description' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.description"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.description ? currentElement.description : ('content.emptyElement' | transloco) }}
                </p>
              </div>
              <div class="element-block">
                <label class="subtitle">{{'content.author' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.author"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.author ? currentElement.author : ('content.emptyElement' | transloco) }}
                </p>
              </div>
            </div>

            <div class="line-blocks">
              <div class="element-block">
                <label class="subtitle">{{'content.date' | transloco }}</label>
                <input *ngIf="isEdit" type="date" class="edit-input"
                       [(ngModel)]="createDtString">
                <p *ngIf="!isEdit">
                  {{ currentElement?.createDt ? (currentElement.createDt | date:'dd.MM.yyyy') : ('content.emptyElement' | transloco) }}
                </p>
              </div>
              <div class="element-block">
                <label class="subtitle">{{'content.targetTable' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.targetTable"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.targetTable ? currentElement.targetTable : ('content.emptyElement' | transloco) }}
                </p>
              </div>
            </div>

            <details class="element-block">
              <summary class="subtitle">{{'content.inputParams' | transloco }}</summary>
              <div class="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th style="width:25%">{{'content.nameParam' | transloco }}</th>
                      <th style="width:10%">{{'content.type' | transloco }}</th>
                      <th style="width:65%">{{'content.description' | transloco }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let param of currentElement.parameters">
                      <td>
                        {{ param.name }}
                      </td>

                      <td>
                        {{ param.type }}
                      </td>

                      <td>
                        <ng-container *ngIf="isEdit; else viewParamDesc">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="param.description">
                      </textarea>
                        </ng-container>
                        <ng-template #viewParamDesc>{{ param.description }}</ng-template>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.steps' | transloco }}</summary>
              <div class="table-wrapper">
                <div class="table-buttons">
                  <button class="add-row" (click)="addRow('steps')" *ngIf="isEdit">{{'content.addRow' | transloco }} (+)</button>
                  <button class="delete-row" *ngIf="isEdit" (click)="deleteRow('steps')">
                    {{ 'content.delRow' | transloco }} (–)
                  </button>
                </div>
                <table>
                  <thead>
                    <tr>
                      <th>{{'content.numberStep' | transloco }}</th>
                      <th style="width:90%">{{'content.description' | transloco }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let step of currentElement.steps; let i = index"
                        [class.selected-row]="isEdit && i === selectedStepIndex"
                        (click)="selectRow(i)">
                      <td>
                        <ng-container *ngIf="isEdit; else viewStepNum">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="step.step">
                      </textarea>
                        </ng-container>
                        <ng-template #viewStepNum>{{ step.step }}</ng-template>
                      </td>

                      <td>
                        <ng-container *ngIf="isEdit; else viewStepDesc">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="step.description">
                      </textarea>
                        </ng-container>
                        <ng-template #viewStepDesc>{{ step.description }}</ng-template>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.exampleUsage' | transloco }}</summary>
              <textarea *ngIf="isEdit" class="edit-textarea"
                        [(ngModel)]="currentElement.exampleUsage"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"></textarea>
              <p class="definition" *ngIf="!isEdit">
                {{ currentElement?.exampleUsage ? currentElement.exampleUsage : ('content.emptyElement' | transloco) }}
              </p>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.definition' | transloco }}</summary>
              <textarea *ngIf="isEdit" class="edit-textarea definition"
                        [(ngModel)]="currentElement.definition"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        style="white-space: pre"
                        cdkAutosizeMinRows="1"></textarea>
              <p *ngIf="!isEdit" class="definition" style="white-space: pre">
                {{ currentElement?.definition ? currentElement.definition : ('content.emptyElement' | transloco) }}
              </p>
            </details>
          </div>

          <!-- Функция -->
          <div *ngIf="elementType==='Function'" class="detail-information">
            <div class="page-buttons">
              <h2>{{currentElement.name}}</h2>
              <div class="history-changes">
                <label class="subtitle">{{'content.historyChange' | transloco }}</label>

                <div class="custom-dropdown" [class.open]="isOpen" (click)="isOpen = !isOpen">
                  <div class="dropdown-header">
                    {{ currentElement?.name || ('content.chooseElement' | transloco)  }}
                  </div>
                  <div class="dropdown-body" *ngIf="isOpen">
                    <div class="dropdown-item"
                         *ngFor="let el of historyElements"
                         (click)="selectElement(el, 'Function')">
                      {{ el.name }} ({{ (el.modifyDt ?? el.createDt) | date:'dd.MM.yyyy HH:mm' }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-blocks">
              <div class="element-block">
                <label class="subtitle">{{'content.description' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.description"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.description ? currentElement.description : ('content.emptyElement' | transloco) }}
                </p>
              </div>
              <div class="element-block">
                <label class="subtitle">{{'content.author' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.author"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.author ? currentElement.author : ('content.emptyElement' | transloco) }}
                </p>
              </div>
            </div>

            <div class="line-blocks">
              <div class="element-block">
                <label class="subtitle">{{'content.date' | transloco }}</label>
                <input *ngIf="isEdit" type="date" class="edit-input"
                       [(ngModel)]="createDtString">
                <p *ngIf="!isEdit">
                  {{ currentElement?.createDt ? (currentElement.createDt | date:'dd.MM.yyyy') : ('content.emptyElement' | transloco) }}
                </p>
              </div>
              <div class="element-block">
                <label class="subtitle">{{'content.targetTable' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.targetTable"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.targetTable ? currentElement.targetTable : ('content.emptyElement' | transloco) }}
                </p>
              </div>
            </div>

            <details class="element-block">
              <summary class="subtitle">{{'content.inputParams' | transloco }}</summary>
              <div class="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th style="width:25%">{{'content.nameParam' | transloco }}</th>
                      <th style="width:10%">{{'content.type' | transloco }}</th>
                      <th style="width:65%">{{'content.description' | transloco }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let param of currentElement.parameters">
                      <td>
                        {{ param.name }}
                      </td>

                      <td>
                        {{ param.type }}
                      </td>

                      <td>
                        <ng-container *ngIf="isEdit; else viewParamDesc">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="param.description">
                       </textarea>
                        </ng-container>
                        <ng-template #viewParamDesc>{{ param.description }}</ng-template>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.steps' | transloco }}</summary>
              <div class="table-wrapper">
                <div class="table-buttons">
                  <button class="add-row" (click)="addRow('steps')" *ngIf="isEdit">{{'content.addRow' | transloco }} (+)</button>
                  <button class="delete-row" *ngIf="isEdit" (click)="deleteRow('steps')">
                    {{ 'content.delRow' | transloco }} (–)
                  </button>
                </div>
                <table>
                  <thead>
                    <tr>
                      <th>{{'content.numberStep' | transloco }}</th>
                      <th style="width:90%">{{'content.description' | transloco }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let step of currentElement.steps; let i = index"
                        [class.selected-row]="isEdit && i === selectedStepIndex"
                        (click)="selectRow(i)">
                      <td>
                        <ng-container *ngIf="isEdit; else viewStepNum">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="step.step">
          </textarea>
                        </ng-container>
                        <ng-template #viewStepNum>{{ step.step }}</ng-template>
                      </td>

                      <td>
                        <ng-container *ngIf="isEdit; else viewStepDesc">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="step.description">
          </textarea>
                        </ng-container>
                        <ng-template #viewStepDesc>{{ step.description }}</ng-template>
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.exampleUsage' | transloco }}</summary>
              <textarea *ngIf="isEdit" class="edit-textarea"
                        [(ngModel)]="currentElement.exampleUsage"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"></textarea>
              <p class="definition" *ngIf="!isEdit">
                {{ currentElement?.exampleUsage ? currentElement.exampleUsage : ('content.emptyElement' | transloco) }}
              </p>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.definition' | transloco }}</summary>
              <textarea *ngIf="isEdit" class="edit-textarea definition"
                        [(ngModel)]="currentElement.definition"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        style="white-space: pre"
                        cdkAutosizeMinRows="1"></textarea>
              <p *ngIf="!isEdit" class="definition" style="white-space: pre">
                {{ currentElement?.definition ? currentElement.definition : ('content.emptyElement' | transloco) }}
              </p>
            </details>
          </div>

          <!-- Представления -->
          <div *ngIf="elementType==='View'" class="detail-information">
            <div class="page-buttons">
              <h2>{{currentElement.name}}</h2>
              <div class="history-changes">
                <label class="subtitle">{{'content.historyChange' | transloco }}</label>

                <div class="custom-dropdown" [class.open]="isOpen" (click)="isOpen = !isOpen">
                  <div class="dropdown-header">
                    {{ currentElement?.name || ('content.chooseElement' | transloco)  }}
                  </div>
                  <div class="dropdown-body" *ngIf="isOpen">
                    <div class="dropdown-item"
                         *ngFor="let el of historyElements"
                         (click)="selectElement(el, 'View')">
                      {{ el.name }} ({{ (el.modifyDt ?? el.createDt) | date:'dd.MM.yyyy HH:mm' }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-blocks">
              <div class="element-block">
                <label class="subtitle">{{'content.description' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.description"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.description ? currentElement.description : ('content.emptyElement' | transloco) }}
                </p>
              </div>
              <div class="element-block">
                <label class="subtitle">{{'content.author' | transloco }}</label>
                <textarea *ngIf="isEdit" class="edit-textarea"
                          [(ngModel)]="currentElement.author"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"></textarea>
                <p *ngIf="!isEdit">
                  {{ currentElement?.author ? currentElement.author : ('content.emptyElement' | transloco) }}
                </p>
              </div>
              <div class="element-block">
                <label class="subtitle">{{'content.date' | transloco }}</label>
                <input *ngIf="isEdit" type="date" class="edit-input"
                       [(ngModel)]="createDtString">
                <p *ngIf="!isEdit">
                  {{ currentElement?.createDt ? (currentElement.createDt | date:'dd.MM.yyyy') : ('content.emptyElement' | transloco) }}
                </p>
              </div>
            </div>

            <details class="element-block">
              <summary class="subtitle">{{'content.definition' | transloco }}</summary>
              <textarea *ngIf="isEdit" class="edit-textarea definition"
                        [(ngModel)]="currentElement.definition"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        style="white-space: pre"
                        cdkAutosizeMinRows="1"></textarea>
              <p *ngIf="!isEdit" class="definition" style="white-space: pre">
                {{ currentElement?.definition ? currentElement.definition : ('content.emptyElement' | transloco) }}
              </p>
            </details>

            <details class="element-block">
              <summary class="subtitle">{{'content.fields' | transloco }}</summary>
              <div class="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>{{'content.columnName' | transloco }}</th>
                      <th>{{'content.type' | transloco }}</th>
                      <th>{{'content.description' | transloco }}</th>
                      <th>{{'content.constraints' | transloco }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let column of currentElement.columns">
                      <td>
                        {{ column.name }}
                      </td>

                      <td>
                        {{ column.type }}
                      </td>

                      <td>
                        <ng-container *ngIf="isEdit; else viewDesc">
                          <textarea cdkTextareaAutosize
                                    #autosize="cdkTextareaAutosize"
                                    cdkAutosizeMinRows="1"
                                    [(ngModel)]="column.description">
  </textarea>
                        </ng-container>
                        <ng-template #viewDesc>{{ column.description }}</ng-template>
                      </td>

                      <td>
                        {{ column.constraints }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </details>


            <details class="element-block">
              <summary class="subtitle">{{'content.exampleUsage' | transloco }}</summary>
              <textarea *ngIf="isEdit" class="edit-textarea"
                        [(ngModel)]="currentElement.exampleUsage"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"></textarea>
              <p class="definition" *ngIf="!isEdit">
                {{ currentElement?.exampleUsage ? currentElement.exampleUsage : ('content.emptyElement' | transloco) }}
              </p>
            </details>
          </div>
        </div>
      </div>

      <!-- Отчеты-->
      <div class="main-part" *ngIf="isShowBI && elementType === 'Report'">
        <div *ngIf="currentElement && elementType === 'Report'" class="detail-information">
          <div class="element-block">
            <div class="page-buttons">
              <a *ngIf="currentDataSource && currentDataSource.dbType && currentDataSource.dbType.toLowerCase() != 'power bi' " [href]="currentElement?.reference" target="_blank" rel="noopener noreferrer">{{currentElement.name}}</a>
              <a style="text-decoration: underline; cursor: pointer;" *ngIf="currentDataSource && currentDataSource.dbType && currentDataSource.dbType.toLowerCase() === 'power bi' && files && files.length > 0" (click)="downloadReportFile(currentElement.id, $event)">{{currentElement.name}}</a>
              <a *ngIf="currentDataSource && currentDataSource.dbType && currentDataSource.dbType.toLowerCase() === 'power bi' && files && files.length === 0">{{currentElement.name}}</a>

              <div class="history-changes">
                <label class="subtitle">{{'content.historyChange' | transloco }}</label>

                <div class="custom-dropdown" [class.open]="isOpen" (click)="isOpen = !isOpen">
                  <div class="dropdown-header">
                    {{ currentElement?.name || ('content.chooseElement' | transloco)  }}
                  </div>
                  <div class="dropdown-body" *ngIf="isOpen">
                    <div class="dropdown-item"
                         *ngFor="let el of historyReports"
                         (click)="displayReport(el.id)">
                      {{ el.name }} ({{ (el.modifyDt ?? el.createDt) | date:'dd.MM.yyyy HH:mm' }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="element-block">
            <label class="subtitle">{{'content.description' | transloco }}</label>
            <textarea *ngIf="isEdit" class="edit-textarea"
                      [(ngModel)]="currentElement.description"
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="10"></textarea>
            <p *ngIf="!isEdit" [innerHTML]="currentElement.description ?? ('content.emptyElement' | transloco)"></p>
          </div>
          <details class="element-block">
            <summary class="subtitle">{{'content.sources' | transloco }}</summary>
            <div *ngFor="let source of currentElement.sources">
              <p class="link-table" *ngIf="!isEdit">{{ source }}</p>
            </div>
          </details>

          <div class="ds-dropdown" style="width:auto" *ngIf="currentDataSource.dbType.toLowerCase() !== 'ssrs'">
            <div class="ds-header" role="button" tabindex="0">
              <span class="ds-title">{{'content.tabs' | transloco }}</span>
            </div>

            <div class="ds-body">
              <div class="chips">
                <button *ngFor="let tab of tabs"
                        type="button"
                        class="chip"
                        [class.selected]="isTabSelected(tab)"
                        (click)="displayTab(tab.id)">
                  {{ tab.name }}
                </button>
              </div>
              <label *ngIf="tabs?.length === 0">
                {{'content.noSources' | transloco }}
              </label>
            </div>
          </div>
          <hr *ngIf="tabs && tabs.length > 0 && currentDataSource.dbType.toLowerCase() !== 'ssrs'" class="dwh-separator" />

          <div class="detail-information" *ngIf="currentTab">
            <p-galleria *ngIf="selectedImage === currentTab.imageBase64"
                        [value]="[{itemImageSrc: currentTab.imageBase64}]"
                        [fullScreen]="true"
                        [(visible)]="isVisibleImage">
              <ng-template pTemplate="item" let-img>
                <img [src]="'data:image/png;base64,' + img.itemImageSrc"
                     style="width: 100%; display: block; cursor: default !important;" />
              </ng-template>

            </p-galleria>


            <img *ngIf="currentTab.imageBase64"
                 [src]="'data:image/png;base64,' + currentTab.imageBase64"
                 (click)="isVisibleImage = true; selectedImage = currentTab.imageBase64">

            <div class="element-block" *ngIf="currentDataSource.dbType.toLowerCase() !== 'ssrs'">
              <label class="subtitle">{{'content.description' | transloco }} </label>
              <textarea *ngIf="isEdit" class="edit-textarea"
                        [(ngModel)]="currentTab.description"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="10">
          </textarea>
              <p *ngIf="!isEdit" class="description" [innerHTML]="currentTab.description ?? ('content.emptyElement' | transloco)"></p>
            </div>
            <details class="element-block">
              <summary>{{'content.filters' | transloco }}</summary>
              <label *ngIf="isEdit && filters && filters[0]" class="subtitle">{{'content.description' | transloco }}</label>
              <textarea *ngIf="isEdit && filters && filters[0]" class="edit-textarea"
                        [(ngModel)]="filters![0].description"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1">
            </textarea>
              <p *ngIf="!isEdit && filters && filters.length > 0 && filters[0]" class="description" [innerHTML]="filters![0].description ?? ('content.emptyElement' | transloco)"></p>


              <p-galleria *ngIf="filters && filters.length > 0 && filters[0].imageBase64 && selectedImage === filters[0].imageBase64"
                          [value]="[{itemImageSrc: filters[0].imageBase64}]"
                          [fullScreen]="true"
                          [(visible)]="isVisibleImage">
                <ng-template pTemplate="item" let-img>
                  <img [src]="'data:image/png;base64,' + img.itemImageSrc"
                       style="width: 100%; display: block; cursor: default !important;" />
                </ng-template>

              </p-galleria>

              <img (click)="isVisibleImage = true; selectedImage = filters[0].imageBase64" class="image-filter" *ngIf="filters && filters.length > 0 && filters[0].imageBase64" [src]="'data:image/png;base64,' +  filters[0].imageBase64">


            </details>
            <details class="element-block">
              <summary>{{'content.charts' | transloco }}</summary>
              <div class="chart" *ngFor="let chart of charts">
                <div class="element-block chart-text">
                  <textarea *ngIf="isEdit" class="edit-textarea element-name"
                            [(ngModel)]="chart.name"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="3">
                  </textarea>
                  <label *ngIf="!isEdit" class="element-name">{{chart.name}}</label>
                  <div style="margin-top: 1rem;">
                    <textarea *ngIf="isEdit" class="edit-textarea description"
                              [(ngModel)]="chart.description"
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="8">
                  </textarea>
                    <p *ngIf="!isEdit" class="description" [innerHTML]="chart.description ?? ('content.emptyElement' | transloco)"></p>
                  </div>
                </div>
                <div class="chart-img">

                  <p-galleria *ngIf="selectedImage === chart.imageBase64"
                              [value]="[{itemImageSrc: chart.imageBase64}]"
                              [fullScreen]="true"
                              [(visible)]="isVisibleImage">
                    <ng-template pTemplate="item" let-img>
                      <img [src]="'data:image/png;base64,' + img.itemImageSrc"
                           style="width: 100%; display: block; cursor: default !important;" />
                    </ng-template>

                  </p-galleria>

                  <img (click)="isVisibleImage = true; selectedImage = chart.imageBase64" class="image-chart" *ngIf="chart.imageBase64" [src]="'data:image/png;base64,' + chart.imageBase64">
                </div>
              </div>
            </details>
          </div>
        </div>
      </div>
      <div class="main-part metric-main-part" *ngIf="isShowBI && elementType === 'ReportMetric'" >
        <div *ngIf="currentElement && elementType === 'ReportMetric'" class="detail-information">
          <h2>{{currentElement.summarizedMetricName}}</h2>
          <div class="element-block">
            <label class="subtitle">{{'content.useInReports' | transloco }}</label>
            <div *ngFor="let report of metricReports">
              <p class="link-table" (click)="displayReport(report.id)">
                {{ report.name }}
              </p>
            </div>
          </div>

          <h4 style="margin: 0;">{{'content.metrics' | transloco }}</h4>
          <details class="element-block metric" *ngFor="let metric of currentElement.metrics">
            <summary class="ds-title" (click)="showMetricInfo(metric.id)">
              {{ metric.rawMetricAlias }}
            </summary>
            <div class="metric-desc element-block">
              <label class="subtitle">{{'content.metricInModel' | transloco }}</label>
              <label>{{ metric.rawMetricName }}</label>
              <label class="subtitle">{{'content.useInReports' | transloco }}:</label>

              <!-- Если есть обработанная структура -->
              <ng-container *ngIf="metric?.usedProcessed; else rawUsed">
                <ng-container *ngFor="let grp of metric.usedProcessed.grouped">
                  <div class="report-block">
                    <div class="flex-display">
                      <p class="link-table" *ngIf="grp.report?.name" (click)="displayReport(grp.report?.id)">
                        {{ grp.report?.name }}
                      </p>
                      <a [href]="grp?.report?.reference" target="_blank" rel="noopener noreferrer">{{'content.referenceToReport' | transloco }}</a>

                    </div>

                    <div class="tabs" *ngIf="grp.tabs?.length">
                      <div *ngFor="let t of grp.tabs">
                        <p class="tab-name" *ngIf="t.tabName"> <b>{{'content.tab' | transloco }}</b> {{ t.tabName }}</p>

                        <ng-container *ngIf="t.charts?.length; else noCharts">
                          <ul class="charts-list">
                            <li *ngFor="let ch of t.charts">{{ ch }}</li>
                          </ul>
                        </ng-container>

                        <ng-template #noCharts>
                          <p class="no-charts">{{'content.noCharts' | transloco }}</p>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <ng-template #rawUsed>
                <div *ngFor="let element of metric?.used">
                  <p class="link-table" *ngIf="element?.report?.name" (click)="displayReport(element?.report?.id)">
                    {{ element?.report?.name }}
                  </p>
                  <a [href]="element?.report?.reference" target="_blank" rel="noopener noreferrer">{{'content.referenceToReport' | transloco }}</a>

                  <p *ngIf="element?.tabName">{{'content.tab' | transloco }} {{ element?.tabName }}</p>

                  <p *ngIf="(element?.chartNames?.length || element?.chart) > 0">{{'content.charts' | transloco }}</p>
                  <ul *ngIf="element?.chartNames?.length">
                    <li *ngFor="let chart of (element?.chartNames || [])">{{ chart }}</li>
                  </ul>
                  <p *ngIf="!element?.chartNames && element?.chart">{{ element?.chart }}</p>
                </div>
              </ng-template>

            </div>
          </details>
        </div>
      </div>
    </div>
</div>

  <app-loading *ngIf="isLoading"></app-loading>
</main>

